<template>
  <div class="product">
    <!--滚动容器-->
    <div
      ref="scrollRef"
      class="product-main"
      :style="{ 'padding-top': `${headerHeight}px` }"
    >
      <div v-if="isDelivery" class="address" @click="googlemapshow">
        <GoogleMapEntrance />
      </div>
      <div v-sticky :style="stickyStyle" class="product-main-sticky">
        <Table v-if="isDine || isFullDineIn" :table-number="tableNumber" />
      </div>
      <Banner v-if="bannerList && bannerList.length > 0" :list="bannerList" :ratio="4" />
      <RecommendProduct class="recommendation">
        <template #default="{ count }">
          <div class="recommend-tile">
            <span bold>{{ $t('common.orderAgain') }}</span>
            <span
              v-if="count > 5"
              primary
              @click="$router.push({ name: 'order-again' })"
            >
              {{ $t('common.seeAll') }}
            </span>
          </div>
        </template>
      </RecommendProduct>
      <div v-sticky :style="tabStickyStyle" class="product-main-sticky">
        <Tabbar ref="tabRef" @onTap="virtualScrollTo" />
      </div>
      <VirtualScroll
        ref="virturlRef"
        :target="$refs.scrollRef"
        :cart-count="cartCountData"
        @onTap="tabScrollTo"
      />
    </div>

    <!--有条件-->
    <ToTop :target="$refs.scrollRef" />
    <MiniCart v-if="showMiniCart" :cart-data="cartData" />
    <!--有条件-->
    <Footer v-if="storeInfo.status && storeInfo.status.statusCode === 400" />
    <GoogleMapDialog ref="mapRef" />
    <q-dialog v-model="err.show" persistent>
      <BaseDialog
        :alert-await.sync="err.show"
        group="payPage"
        :reason.sync="err.reason"
      >
        <template #icon>
          <q-img
            style="width: 64px; height: 64px"
            src="~src/assets/images/result/Upset.png"
          />
        </template>
      </BaseDialog>
    </q-dialog>
    <DialogDownload :show.sync="showDialogDownload" @download="onDownloadDialog" />
    <router-view />
  </div>
</template>

<script>
import fullDineInMixin from 'src/pages/mixin/fullDineInMixin.js';
// eslint-disable-next-line import/order
import { sticky } from './utils';
// eslint-disable-next-line import/order
import { createMeta } from './meta.js';

export default {
  directives: { sticky },
  meta() {
    return createMeta(this);
  },
  mixins: [fullDineInMixin],
};
</script>
<script setup>
/* eslint-disable */
import { useRoute, useRouter } from 'src/utils/v2_helper/router';
import _ from 'lodash';
import { getCartItemData, getCartSimpleData } from 'src/api/cart.js';
import GoogleMapDialog from 'src/components/GoogleMapDialog.vue';
import GoogleMapEntrance from 'src/components/GoogleMapEntrance.vue';
import RecommendProduct from 'src/components/recommend/RecommendProduct.vue';
import { getTableNumber } from 'src/api/checkout.js';
import { use18n, useIns, useStore } from 'src/utils/v2_helper/common';
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import { useStoreCloseDialog } from 'src/utils/hooks/useStoreCloseDialog';
import VirtualScroll from './components/VirtualScroll.vue';
import Banner from './components/Banner.vue';
import MiniCart from './components/MiniCart.vue';
import Footer from './components/Footer.vue';
import Table from './components/Table.vue';
import ToTop from './components/ToTop.vue';
import Tabbar from './components/Tabbar.vue';
import IndexDialog from 'components/dialog/index.vue';
import DialogDownload from 'pages/checkout/components/useVoucher/DialogDownload.vue';
import {
  setTable,
  getTable,
  clearTable,
  getExtraBanner,
} from '../../utils/common';
import { resetFullDine } from '../../utils/updateFullDineInTableData';
import { pushLog } from '../../utils/pushLog';
import { showDialog } from '../../utils/error_config';
import { ADD_SUCCESS_RECOMMEND } from '../../utils/config';
import { getVouchers, isUserRegisterApp } from 'src/api/home';

/* eslint-enable */
const store = useStore();
const app = useIns();
const route = useRoute();
const router = useRouter();
const { $t } = use18n();
const { consume: consumeStoreCloseDialog } = useStoreCloseDialog();

const cartData = ref({});
const cartCountData = ref({});
const tableNumber = ref('');
const err = ref({
  show: false,
  reason: '',
});
const headerHeight = ref(0);
const virturlRef = ref();
const tabRef = ref();
const mapRef = ref();
const scrolling = ref();
const dialogAppPromo = ref(null)

const showDialogDownload = ref(false);

const bannerList = computed(() => {
  const list = store.state?.prefetch?.storeInfo?.bannerList || [];
  const extraBanner = getExtraBanner(app);
  return [...extraBanner, ...list];
  // return list;
});
const scheduled = computed(() => store.state.Menu.scheduled);
const stickyStyle = computed(() => {
  const delivery = app.isDelivery ? 30 : 0;
  return { top: `${delivery}px` };
});
const tabStickyStyle = computed(() => {
  const delivery = app.isDelivery ? 30 : 0;
  const dine = function () {
    if (app.isFullDineIn) return 68;
    if (app.isDine && getTable()) return 68;
    return 0;
  }.call(app);
  return { top: `${delivery + dine}px` };
});
const showMiniCart = computed(() => {
  if (cartData.value?.totalQuantity > 0) {
    if (app.storeOpened) return true;
    if (scheduled.value) return true;
  }
  return false;
});

// fns
function virtualScrollTo(cate) {
  scrolling.value = true;
  virturlRef.value.scrollTo(cate.id); // eslint-disable-next-line no-return-assign
  setTimeout(() => (scrolling.value = false), 300);
}
function tabScrollTo(index) {
  !scrolling.value && tabRef.value.scrollTo(index);
}
function receiveTable() {
  // table logic
  const { query } = route;
  tableNumber.value = query.table || getTable() || '';
  if (tableNumber.value) {
    setTable(tableNumber.value, 1000 * 60 * 60 * 12);
  } else {
    clearTable();
  }
  // full dine in check
  const orderType = query['order-type'];
  const { dineIn, fullDineIn } = app.storeInfo;
  if (orderType) {
    if (orderType === 'DINE_IN' && fullDineIn) {
      store.commit('Menu/updateAccessStatus', 'FULL_DINE_IN');
    } else {
      store.commit('Menu/updateAccessStatus', orderType);
    }
  }
}
async function checkTable() {
  if (app.isFullDineIn && !tableNumber.value) {
    pushLog({
      key: '[PRODUCT_LIST]',
      action: 'checkTable',
      message: `Full Dine in,${tableNumber.value}`,
    });
    showDialog(app, 8003);
    return false;
  }
  // 仅普通dinein模式检查
  if (tableNumber.value && (app.isNormalDineIn || app.isFullDineIn)) {
    const res = await getTableNumber({ keyword: tableNumber.value });
    const tables = res?.data || [];
    if (!tables.includes(tableNumber.value)) {
      showDialog(app, 8003);
      return false;
    }
  }
  return true;
}
// TODO: 修改 检查是否是支持的服务方式
function checkSupportService() {
  const orderTypeForQuery = route.query['order-type'];
  if (orderTypeForQuery && !app.isSupprotService) {
    err.value.reason = `orderType_is_illegal_${orderTypeForQuery}`;
    err.value.show = true;
    return false;
  }
  return true;
}
function googlemapshow() {
  mapRef.value.show = true;
}
function getHeaderHeight() {
  return document.querySelector('#header')?.clientHeight;
}
async function refreshData() {
  // hotfix fix categories error
  store.dispatch('prefetch/prefetchCategories');
  if ((await checkTable()) && checkSupportService()) {
    if (app.isFullDineIn) {
      resetFullDine(app);
      app.onFullDineInChange(
        'cart',
        ({ cart }) => {
          cartData.value = cart;
          store.dispatch('prefetch/getCartDetails', cart);
        },
        { verify: false },
      );
    } else {
      getCartSimpleData().then((res) => {
        cartData.value = res.data;
      });
    }
  } else {
    getCartSimpleData().then((res) => {
      cartData.value = res.data;
    });
  }
  getCartCount()
}
// 获取加购商品的数据 [{id: number}]
function getCartCount() {
  getCartItemData().then((res) => {
    cartCountData.value = res.data;
  });
}
function initBusEvent() {
  app.$bus.$off(ADD_SUCCESS_RECOMMEND, refreshData);
  app.$bus.$on(ADD_SUCCESS_RECOMMEND, refreshData);
}

function showAppPromoDialog() {
  dialogAppPromo.value = app.$q.dialog({
    component: IndexDialog,
    customIcon: 'https://static.bakmigm.co.id/menu-buyer/checkout/discount-icon.svg',
    parent: app,
    ok: $t('order.checkout.claimNow'),
    cancel: $t('list.promo.cancelBtn'),
    title: $t('list.promo.title'),
    describe: $t('list.promo.desc'),
  })
    .onOk(async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        const redirect = route.fullPath.replace(`/${route.params.store}/`, '');
        const splitChar = redirect.indexOf('?') > 0 ? '&' : '?';
        app._rpush({ name: 'login', query: { redirect: `${redirect}${splitChar}from=voucher` } });
        store.dispatch('Menu/resetUser');
      } else {
       await isUserRegister();
      }
//      1. 判断用户是否登录
//      2. 登录的话 判断是否下载 没有的话走下载页面 下载完成直接走提示
//      3. 未登录的话 去走登录 然后重复步骤 2
    })
}

async function isUserRegister () {
  const isRegister = await isUserRegisterApp();
  if (isRegister.data) {
    showAlreadyRegisterDialog()
  } else {
    showAppPromoDialog();
    showDialogDownload.value = true;
  }
}

function showAlreadyRegisterDialog() {
  const dialog = app.$q.dialog({
    component: IndexDialog,
    parent: app,
    type: '',
    ok: $t('common.ok'),
    title: $t('list.promo.register.title'),
    describe: $t('list.promo.register.desc'),
  })
}

function showGeneralReminderDialog() {
  const dialog = app.$q.dialog({
    component: IndexDialog,
    parent: app,
    type: '',
    ok: $t('common.ok'),
    title: $t('list.promo.reminder.title'),
    describe: $t('list.promo.reminder.desc'),
  })
}

const onDownloadDialog = () => {
  dialogAppPromo.value.hide();
  showGeneralReminderDialog();
}
function initVoucher() {
  const { showVoucherDialogList } = store.state.Menu;
  const storeName = router.currentRoute.params.store;
  if (showVoucherDialogList.includes(storeName)) {
    return;
  }
  getVouchers().then((data) => {
    const hasPlatVoucher = data.data && data.data.some(item => item.voucherLevel === 2);
    if (hasPlatVoucher) {
      showAppPromoDialog();
      showVoucherDialogList.push(storeName)
      store.dispatch('Menu/setVoucherDialog', showVoucherDialogList)
    }
  })
}

function initVoucherResult() {
  const isFromVoucher = route.query.from === 'voucher';
  if (isFromVoucher) {
    isUserRegister();
  }
}


watch(
  route,
  (v) => {
    store.commit('prefetch/updateStoreUrl', v.params.store);
    headerHeight.value = getHeaderHeight();
  },
  { immediate: true },
);

onMounted(async () => {
  // init header height;
  await nextTick();
  setTimeout(() => {
    headerHeight.value = getHeaderHeight();
  });
  receiveTable();
  consumeStoreCloseDialog();

  // init bus event
  initBusEvent();

  refreshData();

  const { currentRoute } = router;
  store.dispatch('prefetch/prefetchStoreInfo', { currentRoute });

  // initVoucher();
  // initVoucherResult();
});
onUnmounted(() => {
  app.$bus.$off(ADD_SUCCESS_RECOMMEND, refreshData);
  // 离开清空categores
  store.commit('prefetch/updateCategories', []);
});
</script>

<style scoped lang="scss">
.product {
  position: relative;
  height: 100%;
  overflow: hidden;
  z-index: 1;
  &-main {
    padding-top: 64px;
    height: 100%;
    overflow: auto;
    background: #ebecee;
    &-sticky {
      position: sticky;
      z-index: 999;
      background: #fff;
      top: 0;
    }
    .recommendation {
      background: #fff;
      margin: 8px 0 0;
    }
    .recommend-tile {
      margin-bottom: 8px;
      display: flex;
      justify-content: space-between;
    }
  }
}
.address {
  width: 100%;
  height: 36px;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
}
</style>
